import React, {FC} from "react"

import idHelper from "@irati/utils/id"

import ChangeView from "./ChangeView"
import HomePageGreeting from "./Greeting"
import {Wrapper} from "./styled"
import {HomePageView} from "../types"

interface Props {
  id: string,
  onChangePreview: (view: HomePageView) => void,
  showPreview?: boolean
}

const HomePageHeader: FC<Props> = (props) => {
  const {onChangePreview, showPreview} = props
  const id = idHelper("header", props)

  return (
    <Wrapper id={id} justifyContent="space-between">
      <HomePageGreeting />
      {showPreview && <ChangeView id={id} onChangePreview={onChangePreview} />}
    </Wrapper>
  )
}

export default HomePageHeader
